import type { FC, ReactElement } from 'react';

import { useConfigSlice } from '../../store/slices/config/selectors';
import { useGameStateSlice } from '../../store/slices/game/selectors';

export const HelpFooter: FC = (): ReactElement => {
  const version = useConfigSlice.version();
  const gameId = useGameStateSlice.gameId();

  return (
    <>
      <span>{version}</span>
      <span>{gameId}</span>
    </>
  );
};
